import { REDESIGN_AB_ROUTE_MAP } from 'root/src/client/v2/layout/helpers/redesignAbRoutes';
// Redesign ("nova") routes: the chrome swap (hide the legacy Navigation / Footer, since each redesign
// page mounts its own RedesignNavbar / RedesignFooter, and paint the redesign background) keys off
// this. Two sources:
//   - `/nova/*` (and `/design-preview`): the redesign pages' own routes.
//   - the LEGACY route patterns that now render the redesign in place (the keys of the A/B map). The
//     redesign became the default served AT the existing URLs (e.g. `/drops`, `/e/[recordId]`), so
//     those legacy patterns must count as redesign too, otherwise they would get the legacy chrome.
//
// `pathname` is the Next.js route pattern (`router.pathname`), not the resolved URL.
export const isRedesignRoute = (pathname) => (pathname.startsWith('/nova/')
    || pathname === '/design-preview'
    || pathname in REDESIGN_AB_ROUTE_MAP);
// Full-screen, app-like redesign pages with their own bottom nav that should NOT render the global
// RedesignFooter (it just dangles below the form). The add-campaign wizard is one, at either its
// redesign route or the legacy URL it now renders at.
export const isRedesignFooterlessRoute = (pathname) => (pathname === '/nova/add-campaign' || pathname === '/add-campaign');
